import lozad from 'lozad';
import $ from '../../plugins/query';

export default class LozadController {
    constructor() {
    }

    initScrollToContent() {
        const elements = document.querySelectorAll(this.scrollToContentSelector);
        for (let i = 0; i < elements.length; i++) {
            const targetSelector = elements[i].dataset.target;
            elements[i].addEventListener('click', () => {
                const navOffset = document.querySelector('header.nav-header').offsetHeight;
                const targetElementPosition = document.querySelector(targetSelector).getBoundingClientRect().top;
                const offsetPosition = targetElementPosition - navOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth',
                });
            });
        }
    }

    static init() {
        $(document).ready(() => {
            // lazy loads elements with default selector as '.lozad'
            const observer = lozad('.lozad', {
                loaded(el) {
                    el.classList.add('loaded');
                },
            });
            observer.observe();
        });
    }
}



